import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useSaveProvidersSettings = () => {
  return useMutation({
    mutationFn: (payload: any) => {
      return api.providers.saveMailingProviders({ currentProvider: payload })
    },
    onSuccess: () => {
      toaster.create({
        type: 'success',
        title: 'Данные успешно обновлены',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при сохранении конфигурации провайдеров',
        description: err.message,
      })
    },
  })
}
